import { z } from 'zod';
/**
 * Requisiti di ammissione di una lega (lineeguida §22–§23), salvati in
 * League.settings.admission. Tutto configurabile, niente di obbligatorio.
 */
export const admissionSettingsSchema = z.object({
    /** Requisiti testuali auto-dichiarati (es. "scontrino minimo di €20 per aperitivo"). */
    requirements: z.array(z.string().trim().min(3).max(200)).max(20).default([]),
    /** Quiz di ammissione. */
    quiz: z.object({
        enabled: z.boolean().default(false),
        /** Domande estratte a caso dalla banca per ogni tentativo. */
        questionCount: z.number().int().min(1).max(50).default(12),
        /** Risposte corrette minime per passare. */
        minCorrect: z.number().int().min(1).max(50).default(10),
        /** Tempo massimo in minuti. */
        timeLimitMinutes: z.number().int().min(1).max(120).default(20),
        /** Tentativi massimi per utente. */
        maxAttempts: z.number().int().min(1).max(20).default(3),
    }),
});
export const DEFAULT_ADMISSION = admissionSettingsSchema.parse({
    requirements: [],
    quiz: {},
});
export const quizQuestionSchema = z.object({
    question: z.string().trim().min(5, 'La domanda è troppo corta').max(500),
    options: z
        .array(z.string().trim().min(1).max(200))
        .min(2, 'Servono almeno 2 risposte')
        .max(6, 'Massimo 6 risposte'),
    correctIndex: z.number().int().min(0),
});
export const quizSubmitSchema = z.object({
    attemptId: z.string().min(1),
    answers: z
        .array(z.object({
        questionId: z.string().min(1),
        answerIndex: z.number().int().min(0).max(10),
    }))
        .max(50),
});
//# sourceMappingURL=admission.js.map